<template>
  <div
    class="language-button"
    :class="{
      hidden: dropdownOpen
    }"
    @click="changeDropdown"
  >
    <span class="mr-1">{{ codeLang }}</span>
    <ChevronDown />
  </div>
  <div
    class="languages-dropdown"
    :class="{
      hidden: !dropdownOpen
    }"
  >
    <ul
      class="dropdown-container"
    >
      <li
        v-for="(lang, index) in codeLangs"
        :key="index"
        class="language my-2"
        :class="{
          selected: lang === codeLang
        }"
        @click="changeLanguage(lang)"
      >
        <span>
          {{ lang }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import ChevronDown from '@/components/ChevronDown.vue'
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
  name: 'Languages',
  data () {
    return {
      dropdownOpen: false
    }
  },
  components: {
    ChevronDown
  },
  computed: {
    ...mapState(['codeLang', 'codeLangs'])
  },
  methods: {
    ...mapMutations(['changeLang']),
    ...mapActions(['getChangeLanguages']),
    changeDropdown () {
      this.dropdownOpen = !this.dropdownOpen
    },
    changeLanguage (lang) {
      this.changeLang(lang)
      this.getChangeLanguages()
      this.changeDropdown()
    }
  }
}
</script>

<style>
.language-button {
  --tw-bg-opacity: 1;
  background-color: rgba(248, 248, 248, var(--tw-bg-opacity));
  border-radius: 1rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  font-weight: 700;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  --tw-text-opacity: 1;
  color: rgba(50, 51, 147, var(--tw-text-opacity));
}
.hidden {
  display: none;
  -webkit-transition-property: background-color, border-color, color, fill, stroke, opacity, -webkit-box-shadow, -webkit-transform, filter, backdrop-filter;
  -o-transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, -webkit-box-shadow, transform, -webkit-transform, filter, backdrop-filter;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
  -webkit-transition-duration: 75ms;
  -o-transition-duration: 75ms;
  transition-duration: 75ms;
}
.dropdown-container {
  --tw-bg-opacity: 1;
  background-color: rgba(248, 248, 248, var(--tw-bg-opacity));
  border-radius: 1rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  position: absolute;
  top: 20px;
  right: 20px;
  --tw-shadow-color: 0, 0, 0;
  --tw-shadow: 0 4px 6px -1px rgba(var(--tw-shadow-color), 0.1), 0 2px 4px -1px rgba(var(--tw-shadow-color), 0.06);
  -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-text-opacity: 1;
  color: rgba(141, 141, 141, var(--tw-text-opacity));
  -webkit-transition-property: background-color, border-color, color, fill, stroke, opacity, -webkit-box-shadow, -webkit-transform, filter, backdrop-filter;
  -o-transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, -webkit-box-shadow, transform, -webkit-transform, filter, backdrop-filter;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  -webkit-transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  -webkit-transition-duration: 100ms;
  -o-transition-duration: 100ms;
  transition-duration: 100ms;
}
.dropdown-container .selected {
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgba(50, 51, 147, var(--tw-text-opacity));
}
.language-button:hover, .language:hover {
  cursor: pointer;
}
</style>
